// @flow

import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import Icon from './Icon';

type Props = {
  className?: string,
  link?: string,
  onClick?: () => void,
  stopPropagation?: boolean,
  preventDefault?: boolean,
  title?: string
};

const Wrapper = styled(({ link, onClick, ...restProps }) =>
  link ? (
    <Link to={link} {...restProps} />
  ) : (
    <button type="button" onClick={onClick} {...restProps} />
  )
)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 0
});

function SvgButton(props: Props) {
  const { className, link, onClick, stopPropagation, preventDefault, title, ...otherProps } = props;

  const handleClick = e => {
    if (preventDefault) {
      e.preventDefault();
    }
    if (stopPropagation) {
      e.stopPropagation();
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <Wrapper className={className} link={link} onClick={handleClick} title={title}>
      <Icon {...otherProps} />
    </Wrapper>
  );
}

SvgButton.defaultProps = {
  className: undefined,
  link: undefined,
  onClick: undefined,
  stopPropagation: false,
  preventDefault: false,
  title: undefined
};

export default SvgButton;
